import { defineSlotRecipe } from '@chakra-ui/react';
import fonts from '../fonts';

const numericStyles = {
  '&[data-is-numeric=true]': {
    textAlign: 'end',
  },
};

const Table = defineSlotRecipe({
  slots: ['root', 'cell', 'footer', 'caption'],
  base: {
    cell: {
      border: 'none',
    },
  },
  variants: {
    visual: {
      unstyled: {},
      costBreakdown: {
        root: {
          fontVariantNumeric: 'lining-nums tabular-nums',
          fontSize: '14px',
        },
        cell: {
          ...numericStyles,
          textAlign: 'start',
          py: '6px',
          px: 0,
          lineHeight: '24px',
          color: 'podcastShade500',
          borderWidth: 0,
          borderColor: 'white',
        },
        footer: {
          ...numericStyles,
          fontSize: '16px',
          fontFamily: fonts.bold,
          borderTop: '1px solid',
          borderColor: 'podcastShade200',
          '&cell': {
            pt: '14px',
            color: 'podcastShade600',
          },
        },
        caption: {
          pt: 0,
          mt: 0,
          px: 0,
          fontFamily: fonts.normal,
          textAlign: 'right',
          color: 'podcastShade500',
        },
      },
      transcript: {
        cell: {
          px: '5px',
          py: '5px',
          verticalAlign: 'top',
        },
      },
    },
  },
  defaultVariants: {
    visual: 'unstyled',
  },
});

export default Table;
